<template>
  <b-row class="my-4">
    <b-col class="overflow-auto">
      <b-pagination-nav
        v-model="page"
        @input="input"
        :link-gen="linkGen"
        :number-of-pages="pagination.last_page"
        use-router
      ></b-pagination-nav>
      <small v-if="pagination.total > 0">
        Exibindo {{ pagination.from }} a {{ pagination.to }} de um total de
        {{ pagination.total }} registros
      </small>
    </b-col>

    <b-col>
      <b-form-group
        label="Exibir"
        label-cols="8"
        label-align="right"
        label-size="sm"
      >
        <b-form-select
          v-model="pagination.per_page"
          :options="pageOptions"
          size="sm"
        ></b-form-select>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import _ from "lodash";
export default {
  props: {
    pagination: {
      default: () => ({
        current_page: 1,
        last_page: 1,
        from: 1,
        to: 1,
        per_page: 15,
        total: 0,
      }),
    },
  },
  data: () => ({
    page: 0,
    pageOptions: [5, 10, 15, 50],
  }),
  methods: {
    linkGen(pageNum) {
      var query = this.$route.query;
      pageNum > 1 ? (query.page = pageNum) : delete query.page;

      let str = Object.entries(query)
        .map(([key, val]) => `${key}=${val}`)
        .join("&");

      return "?" + str;
    },
    input(page) {
      this.pagination.current_page = page;
      this.$emit("input", this.pagination.current_page);
    },
  },
  watch: {
    "pagination.per_page": {
      deep: true,
      handler: function (value, old) {
        if (_.isNumber(old) && value != old) {
          this.$emit("input", this.pagination.current_page);
        }
      },
    },
  },
  created() {
    this.page = this.pagination.current_page;
  },
};
</script>

<style>
</style>
